import { useEffect } from 'react'
import { Field, useForm, useFormState } from 'react-final-form'

import { ListCepIntegrationResponse } from 'common/api'
import FormItem from 'common/components/formItem'
import Select, { Option } from 'common/components/Select'

import FormCard, { FormCardTitle } from '../formCard'

type Props = {
  accountsIntegration: ListCepIntegrationResponse | undefined
  contextCepIntegrationId?: string
}

const CepIntegrationCard = ({
  accountsIntegration,
  contextCepIntegrationId,
}: Props) => {
  const formState = useFormState()
  const { change: formChange } = useForm()
  const { cepIntegrationId } = formState.values

  useEffect(() => {
    if (cepIntegrationId) {
      formChange('cepIntegrationId', cepIntegrationId)
    }
  }, [cepIntegrationId, formChange])

  return (
    <FormCard data-id="cep-integration-card" data-testid="cep-integration-card">
      <FormCardTitle title="My Integration" />
      <Field<string> name="cepIntegrationId">
        {({ input }) => (
          <FormItem label="Integration">
            <Select
              className="w-full"
              placeholder="Select..."
              value={input.value || contextCepIntegrationId}
              onChange={(integrationId) => {
                formChange('cepIntegrationId', integrationId)
              }}
            >
              {accountsIntegration?.map((value) => (
                <Option key={value._id} value={value?._id!}>
                  {value.name}
                </Option>
              ))}
            </Select>
          </FormItem>
        )}
      </Field>
    </FormCard>
  )
}

export default CepIntegrationCard
